import { ConfirmDialog } from "@simplicity/ui";

import { type DashboardRow } from "./types";

export function DashboardDeleteDialog({
  dashboards,
  deleteId,
  onClose,
  onConfirm,
}: {
  dashboards: DashboardRow[];
  deleteId: string | null;
  onClose: () => void;
  onConfirm: (id: string) => void;
}) {
  const title = dashboards.find((d) => d.id === deleteId)?.title;
  return (
    <ConfirmDialog
      open={!!deleteId}
      onOpenChange={(open) => !open && onClose()}
      title="Delete Dashboard"
      description={
        <>
          Are you sure you want to permanently delete &quot;{title}&quot;? This action cannot be
          undone.
        </>
      }
      onConfirm={() => {
        if (deleteId) onConfirm(deleteId);
      }}
      options={{ destructive: true, confirmLabel: "Delete" }}
    />
  );
}
